import './ThermalReceipt.css';

const ThermalReceipt = ({ title, subtitle, meta = [], footerNote, logoSrc, logoAlt = 'Store logo', children }) => {
    return (
        <div className="thermal-receipt" data-testid="thermal-receipt">
            {(logoSrc || title || subtitle) && (
                <div className="thermal-receipt__header">
                    {logoSrc && <img src={logoSrc} alt={logoAlt} className="thermal-receipt__logo" width={400} height={184} />}
                    <div className="thermal-receipt__heading-copy">
                        {title && <p className="thermal-receipt__title">{title}</p>}
                        {subtitle && <p className="thermal-receipt__subtitle">{subtitle}</p>}
                    </div>
                </div>
            )}
            {meta.length > 0 && (
                <dl className="thermal-receipt__meta">
                    {meta.map(({ label, value }, index) => (
                        <div className="thermal-receipt__meta-row" key={`${label}-${index}`}>
                            <dt>{label}</dt>
                            <dd>{value}</dd>
                        </div>
                    ))}
                </dl>
            )}
            <div className="thermal-receipt__body">{children}</div>
            {footerNote && <p className="thermal-receipt__footer">{footerNote}</p>}
        </div>
    );
};

export const ThermalReceiptSection = ({ title, children, padTop = true, showSeparator = true }) => (
    <section className={`thermal-receipt__section${padTop ? ' thermal-receipt__section--padded' : ''}`}>
        {title && <p className="thermal-receipt__section-title">{title}</p>}
        <div className="thermal-receipt__section-content">{children}</div>
        {showSeparator && <div className="thermal-receipt__separator" />}
    </section>
);

export const ThermalReceiptRow = ({ label, value, emphasize }) => (
    <div className={`thermal-receipt__row${emphasize ? ' thermal-receipt__row--emphasize' : ''}`}>
        <span className="thermal-receipt__label">{label}</span>
        <span className="thermal-receipt__value">{value}</span>
    </div>
);

export default ThermalReceipt;
